import React from 'react';
import { Button } from '../ui';
import { CheckCircle2, XCircle, Clock, Ban, RotateCcw, ArrowRight } from 'lucide-react';

export function StatusPagamento({ resultado, corridaNome, onFinished }) {
  const statusMap = {
    accredited: {
      icon: CheckCircle2,
      titulo: 'Pagamento Aprovado!',
      mensagem: 'Sua inscrição foi confirmada com sucesso! O comprovante com QR Code foi enviado para o seu e-mail e também pode ser visualizado em Minhas Corridas.',
      colorClass: 'text-green-400 border-green-500/30 bg-green-500/10',
      btnVariant: 'primary',
    },
    approved: {
      icon: CheckCircle2,
      titulo: 'Pagamento Aprovado!',
      mensagem: 'Sua inscrição foi confirmada com sucesso! O comprovante com QR Code foi enviado para o seu e-mail e também pode ser visualizado em Minhas Corridas.',
      colorClass: 'text-green-400 border-green-500/30 bg-green-500/10',
      btnVariant: 'primary',
    },
    Inscrito: {
      icon: CheckCircle2,
      titulo: 'Inscrição Confirmada!',
      mensagem: 'Sua inscrição foi confirmada com sucesso! O comprovante com QR Code foi enviado para o seu e-mail e também pode ser visualizado em Minhas Corridas.',
      colorClass: 'text-green-400 border-green-500/30 bg-green-500/10',
      btnVariant: 'primary',
    },
    approved: {
      icon: CheckCircle2,
      titulo: 'Pagamento Aprovado!',
      mensagem: 'Sua inscrição foi confirmada com sucesso! Você pode visualizar os detalhes em Minhas Corridas.',
      colorClass: 'text-green-400 border-green-500/30 bg-green-500/10',
      btnVariant: 'primary',
    },
    Inscrito: {
      icon: CheckCircle2,
      titulo: 'Inscrição Confirmada!',
      mensagem: 'Sua inscrição foi confirmada com sucesso! Você pode visualizar os detalhes em Minhas Corridas.',
      colorClass: 'text-green-400 border-green-500/30 bg-green-500/10',
      btnVariant: 'primary',
    },
    CONFIRMED: {
      icon: CheckCircle2,
      titulo: 'Pagamento Confirmado!',
      mensagem: 'Sua inscrição foi confirmada com sucesso! O comprovante com QR Code foi enviado para o seu e-mail e também pode ser visualizado em Minhas Corridas.',
      colorClass: 'text-green-400 border-green-500/30 bg-green-500/10',
      btnVariant: 'primary',
    },
    RECEIVED: {
      icon: CheckCircle2,
      titulo: 'Pagamento Recebido!',
      mensagem: 'Sua inscrição foi confirmada com sucesso! O comprovante com QR Code foi enviado para o seu e-mail e também pode ser visualizado em Minhas Corridas.',
      colorClass: 'text-green-400 border-green-500/30 bg-green-500/10',
      btnVariant: 'primary',
    },
    rejected: {
      icon: XCircle,
      titulo: 'Pagamento Recusado',
      mensagem: 'Não foi possível aprovar a transação. Por favor, verifique os dados do cartão ou tente outro método.',
      colorClass: 'text-red-400 border-red-500/30 bg-red-500/10',
      btnVariant: 'danger',
    },
    pending: {
      icon: Clock,
      titulo: 'Aguardando Confirmação',
      mensagem: 'Seu pagamento está sendo processado. Assim que for confirmado, o status será atualizado.',
      colorClass: 'text-amber-400 border-amber-500/30 bg-amber-500/10',
      btnVariant: 'secondary',
    },
    PENDING: {
      icon: Clock,
      titulo: 'Aguardando Confirmação',
      mensagem: 'Seu pagamento está sendo processado. Assim que for confirmado, o status será atualizado.',
      colorClass: 'text-amber-400 border-amber-500/30 bg-amber-500/10',
      btnVariant: 'secondary',
    },
    cancelled: {
      icon: Ban,
      titulo: 'Pagamento Cancelado',
      mensagem: 'O pagamento foi cancelado.',
      colorClass: 'text-slate-400 border-slate-700 bg-slate-800/40',
      btnVariant: 'secondary',
    },
    OVERDUE: {
      icon: Clock,
      titulo: 'Pagamento Expirado',
      mensagem: 'O prazo para realização deste pagamento expirou.',
      colorClass: 'text-red-400 border-red-500/30 bg-red-500/10',
      btnVariant: 'danger',
    },
    REFUNDED: {
      icon: RotateCcw,
      titulo: 'Pagamento Estornado',
      mensagem: 'Este pagamento foi estornado.',
      colorClass: 'text-slate-400 border-slate-700 bg-slate-800/40',
      btnVariant: 'secondary',
    },
  };

  const statusKey = resultado?.status_detail || resultado?.status || 'pending';
  const info = statusMap[statusKey] || statusMap['pending'];
  const IconComponent = info.icon;

  return (
    <div className={`p-6 rounded-2xl border text-center flex flex-col items-center gap-4 ${info.colorClass}`}>
      <IconComponent className="w-16 h-16" />
      <div>
        <h2 className="text-2xl font-extrabold text-white m-0 mb-1">
          {resultado?.titulo || info.titulo}
        </h2>
        {corridaNome && (
          <p className="font-semibold text-base text-slate-300 m-0">
            Corrida: {corridaNome}
          </p>
        )}
      </div>

      <p className="text-slate-300 text-sm max-w-md m-0">
        {resultado?.mensagem || info.mensagem}
      </p>

      {resultado?.order_id && (
        <span className="text-xs font-mono text-slate-400 px-3 py-1 rounded bg-black/40 border border-white/10">
          Ref ID: {resultado.order_id}
        </span>
      )}

      {onFinished && (
        <Button
          onClick={onFinished}
          variant={info.btnVariant}
          className="mt-2 flex items-center gap-2 px-6 py-2.5 font-bold"
        >
          <span>Continuar</span>
          <ArrowRight className="w-4 h-4" />
        </Button>
      )}
    </div>
  );
}

export default StatusPagamento;
